import React from 'react';
import { observer } from 'mobx-react-lite';

const GameMainBackSideLines = observer(() => {
  return (
    <div className='monti-game-backside-decorations'>
      <div className='monti-game-backside-decorations-inside' />
    </div>
  );
});

export default GameMainBackSideLines;
